<app-spinner-overlay></app-spinner-overlay>
<div mat-dialog-content class="dialog-center-compilazione" *ngIf="isReady">
  <swiper-container
    [simulateTouch]="false"
    auto-height="true"
    #swiperAmbiti
    (swiperslidechange)="onSlideChange()"
  >
    <swiper-slide class="ambito" *ngFor="let amb of ambiti; let idxAmb = index">
      <div class="titolo">Ambito - {{ amb.titolo }} - {{ amb.descrizione }}</div>

      <swiper-container [simulateTouch]="false" auto-height="true" #swiperTematiche>
        <swiper-slide *ngFor="let tema of amb.tematiche; let idxTem = index">
          <div class="tematiche">
            <div *ngIf="tema.domanda" class="domanda">Tematica - {{ tema.domanda }}</div>

            <div *ngIf="tema.descrizione" class="descrizione">
              {{ tema.descrizione }}
            </div>

            @if (tema.tipo === 'scelta_multipla') {
              @if (tema.modalita === 'QUESTIONARIO') {
                <div class="indicazione-selezione">
                  {{
                    tema.multirisposta
                      ? 'Seleziona una o più risposte'
                      : 'Seleziona una sola risposta'
                  }}
                </div>
              }
              @for (opz of tema.opzioni; let idxOpz = $index; track $index) {
                <div
                  class="checkbox-group"
                  [ngStyle]="{ 'margin-top': idxOpz > 0 ? '5px' : '0px' }"
                >
                  <mat-checkbox
                    #checkboxOpz
                    [value]="opz.chiave"
                    [disabled]="disableForm"
                    [checked]="(tema?.risposte || []).indexOf(opz.chiave) > -1"
                    (change)="cambioCheckOpzione($event, tema, opz)"
                  >
                    <span class="descrizione"> {{ opz.valore }}</span>
                  </mat-checkbox>

                  <div class="sotto-opzioni" *ngIf="opz.sottoOpzioni.length && checkboxOpz.checked">
                    <div *ngFor="let opzSec of opz.sottoOpzioni" class="radio-group">
                      <!-- CHECKBOX -->
                      <ng-container *ngIf="opzSec.tipo === 'checkbox'">
                        <div class="checkbox-wrapper">
                          <mat-checkbox
                            #checkSottoOpzioneAttiva
                            [value]="opzSec.chiave"
                            [disabled]="disableForm"
                            [checked]="opzSec.checked"
                            (change)="sottoOpzAzioneKpiChecked($event, opzSec, tema, opz)"
                          >
                            <span class="descrizione" style="padding-bottom: 0px; font-weight: 500">
                              {{ opzSec.valore }}
                            </span>
                          </mat-checkbox>
                        </div>
                      </ng-container>

                      <!-- AZIONE -->
                      <ng-container *ngIf="opzSec.tipo === 'azione'">
                        <div class="checkbox-wrapper">
                          <mat-checkbox
                            #checkSottoOpzioneAttiva
                            [checked]="opzSec.checked"
                            [disabled]="disableForm"
                            (change)="sottoOpzAzioneKpiChecked($event, opzSec, tema, opz)"
                          >
                            <span class="descrizione" style="padding-bottom: 0px; font-weight: 500">
                              {{ opzSec.titolo }}
                            </span>
                          </mat-checkbox>
                        </div>

                        <mat-label
                          class="descrizione"
                          style="
                            padding-bottom: 15px;
                            color: var(--grigio);
                            padding-left: 45px;
                            font-size: 13px;
                          "
                          >{{ opzSec.descrizione }}</mat-label
                        >

                        <div
                          appFormContainer
                          [larghezza]="3"
                          *ngIf="checkSottoOpzioneAttiva.checked"
                          style="padding-left: 40px"
                        >
                          <mat-form-field [larghezza]="2" appFormElement>
                            <mat-label>Risposta</mat-label>
                            <textarea
                              matInput
                              #textArea
                              [placeholder]="'Risposta'"
                              rows="4"
                              [disabled]="disableForm"
                              [(ngModel)]="opzSec.risposta"
                            ></textarea>
                            <mat-error appFormError></mat-error>
                          </mat-form-field>
                        </div>
                      </ng-container>

                      <!-- KPI -->
                      <ng-container *ngIf="opzSec.tipo === 'kpi'">
                        <div class="checkbox-wrapper">
                          <mat-checkbox
                            #checkSottoOpzioneAttiva
                            [checked]="opzSec.checked"
                            [disabled]="disableForm"
                            (change)="sottoOpzAzioneKpiChecked($event, opzSec, tema, opz)"
                          >
                            <span class="descrizione" style="padding-bottom: 0px; font-weight: 500">
                              {{ opzSec.nomeBreve }}
                            </span>
                          </mat-checkbox>
                        </div>

                        <mat-label
                          class="descrizione"
                          style="
                            padding-bottom: 15px;
                            color: var(--grigio);
                            padding-left: 45px;
                            font-size: 13px;
                          "
                          >{{ opzSec.descrizione }}</mat-label
                        >

                        <div
                          appFormContainer
                          [larghezza]="3"
                          style="padding-left: 40px"
                          *ngIf="checkSottoOpzioneAttiva.checked"
                        >
                          <mat-form-field appFormElement [larghezza]="1">
                            <mat-label>Unità di Misura</mat-label>
                            <mat-select
                              [placeholder]="'Unità di Misura'"
                              [disabled]="disableForm"
                              [(ngModel)]="opzSec.valoriKpi[0].idUnitaDiRiferimento"
                            >
                              <mat-option
                                *ngFor="
                                  let um of arrayUm[opzSec.valoriKpi[0].idCategoriaUnitaDiMisura]
                                "
                                [value]="um.id"
                                >{{ um.descrizione }}</mat-option
                              >
                            </mat-select>
                          </mat-form-field>

                          <mat-form-field appFormElement [larghezza]="1">
                            <mat-label>Risposta</mat-label>
                            <input
                              matInput
                              [placeholder]="'Risposta'"
                              [disabled]="disableForm"
                              [(ngModel)]="opzSec.valoriKpi[0].valoreAttribuito"
                              type="number"
                              appInputNumber
                              step="0.01"
                              inputmode="numeric"
                            />
                            <mat-error appFormError></mat-error>
                          </mat-form-field>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </swiper-slide>
      </swiper-container>
    </swiper-slide>
  </swiper-container>
</div>

<div mat-dialog-actions class="dialog-footer-cont" style="justify-content: space-between">
  <div style="display: flex; column-gap: 10px">
    <div>
      <button mat-flat-button color="accent" (click)="indietro()" class="accent-button">
        {{ currentSlideIndex === 0 ? 'Chiudi' : 'Indietro' }}
      </button>
    </div>
    <div>
      <button
        mat-flat-button
        color="primary"
        (click)="avanti()"
        class="primary-button"
        #btnAvanti
        [disabled]="!ambiti[indexAmbitoCorrente].tematiche[indexTematicaCorrente].risposte?.length"
      >
        {{ currentSlideIndex + 1 === totTematiche ? 'Fine' : 'Avanti' }}
      </button>
    </div>
  </div>

  <div class="index-paginator">{{ currentSlideIndex + 1 }}/{{ totTematiche }}</div>
</div>
